<template>
	<div class="order-body">
		<Search :ids="ids" :options="options" :AuthorityList='AuthorityList' :orderKey='orderKey' :orderBy='orderBy' ref='searchRef' @handleSearch="handleSearch"/>
		<MainTable
			:size='size'
			:page='page'
			:tableData='tableData'
			:totalCount='totalCount'
			:AuthorityList='AuthorityList'
			:dateValue='dateValue'
			@sortSearch="sortSearch"
			@handleSize='handleSizeChange'
			@handlePage='handlePageChange'
		/>
	</div>
</template>

<script>
import Search from '@/components/achievement/Search.vue'
import MainTable from '@/components/achievement/MainTable.vue'
export default {
	name: 'achievement',
	components: {
		Search,
		MainTable
	},
	data () {
		return {
			AuthorityList: {
				'11_0002_0001_00': false,
				'11_0002_0002_00': false
			},
			staff: [],
			orderKey: '',
			orderBy: '',
			page: 1,
			size: 20,
			tableData: [],
			totalCount: 0,
			tabParams: {},
			totalOrderCount: 0,
			dateValue: [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59'],
			ids: [],
			options: []
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '13-2')
		this.getAuthority('11_0002_0000_00')
		this.openPage()
	},
	methods: {
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		openPage () {
			this.findUserName()
			this.findOrderList()
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.findOrderList()
		},
		handlePageChange (value) {
			this.page = value
			this.findOrderList()
		},
		handleSearch (data) {
			this.staff = data.staff
			this.dateValue = data.dateValue

			this.page = 1
			this.findOrderList()
		},
		sortSearch (data) {
			this.orderKey = data.orderKey
			this.orderBy = data.orderBy
			this.findOrderList()
		},
		findOrderList () {
			this.tableData = []
			let params = {
				staffIds: this.staff,
				orderKey: this.orderKey,
				orderBy: this.orderBy,
				page: this.page,
				size: this.size
			}
			if (this.dateValue.length > 0) {
				params.beginDate = this.dateValue[0]
				params.endDate = this.dateValue[1]
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/commissionResultSummaryList`,
				data: params
			}).then(res => {
				this.totalCount = res.recordCount
				res.recordList.forEach(e => {
					if (!(String(e.sumcommissionmoney).indexOf('.') !== -1 && String(e.sumcommissionmoney).split('.')[1].length > 2)) {
						e.sumcommissionmoney = this.$fxUtils.toFixedSHW(e.sumcommissionmoney, 2)
					}
					if (!(String(e.commissionmoney).indexOf('.') !== -1 && String(e.commissionmoney).split('.')[1].length > 2)) {
						e.commissionmoney = this.$fxUtils.toFixedSHW(e.commissionmoney, 2)
					}
					if (!(String(e.nocommissionmoney).indexOf('.') !== -1 && String(e.nocommissionmoney).split('.')[1].length > 2)) {
						e.nocommissionmoney = this.$fxUtils.toFixedSHW(e.nocommissionmoney, 2)
					}
					e.staffname = e.staffname.split(',')
					e.name = e.staffname[e.staffname.length - 1]
				})
				this.tableData = res.recordList
			})
		},
		findUserName () {
			let params = {
				userName: ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/staff/getStaffInfoForCondition`,
				data: params
			}).then(res => {
				this.options = res.data
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	flex: 1
	display flex
	flex-direction column
	.shop-position {
		display flex
		align-items: center
		height: 50px
		min-height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-menu {
		height: 50px
		display flex
		position relative
		border-bottom: 1px solid #dce1fe
		li {
			height: 100%
			line-height: 49px
			margin-right: 60px
			font-size: 15px
			// font-weight: 700
			box-sizing:border-box
			cursor: pointer
			position: relative
			color: #595959
			&.active {
				color: var(--fx-primary-color)
				border-bottom: 2px solid var(--fx-primary-color)
			}
			span {
				position: absolute;
				width: 18px;
				height: 18px;
				line-height: 18px;
				border-radius: 50%;
				font-size: 11px;
				top: 5px;
				right: -18px;
				text-align: center;
				background-color: #EC4141;
				color: #fff;
				&.big-num {
					width: 28px;
					border-radius: 40px;
					right: -28px;
				}
			}
		}
		div {
			height: 100%
			line-height: 49px
			font-size: 14px
			font-weight: 700
			box-sizing:border-box
			position absolute;
			top: 0;
			right: 50px;
		}
	}
}
</style>
<style lang="stylus">
.order-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
